import { Button, Image, TextSize, Weight } from 'components'

import AllPortfolio from 'assets/portfolio/all-portfolio.svg?react'
import DownChevron from 'assets/portfolio/down-chevron.svg?react'
import { PortfolioChartComponent } from 'components/charts/portfolio-chart'
import styled from 'styled-components'

export const SelectBox = styled.div`
  gap: 20px;
  width: 100%;
  border-radius: 20px;
  padding: 20px;
`

export const SelectItemBaseStyle = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${TextSize.two};
  font-weight: ${Weight.Medium};
  line-height: 27.158px;
  align-items: center;
  cursor: pointer;
  max-width: 337px;
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const Item = styled(SelectItemBaseStyle)`
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  width: calc(100% - 40px);
  height: 48px;
  border-radius: 10px;
  padding: 0 20px 0 20px;
  :hover {
    background-color: ${({ theme }) => theme.switchBgColor};
  }
  align-items: center;
`

export const AllItem = styled(SelectItemBaseStyle)`
  padding-bottom: 10px;
  height: 37px;
`

export const PortfolioIcon = styled(AllPortfolio)`
  width: 24px;
  height: 24px;
`

export const DownChevronIcon = styled(DownChevron)<{ open: boolean }>`
  width: 12px;
  height: 12px;
  transition: transform 0.5s;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  & > path {
    stroke: ${({ theme }) => theme.primaryFontColor};
  }
`

export const SelectItemWrapper = styled.div<{ isOpen: boolean }>`
  border-radius: 20px;
  background-color: ${({ theme }) => theme.bg};
  transition: height 0.5s;
  padding: 0 20px 20px 20px;
  position: relative;
  left: -20px;
  width: 337px;
  box-shadow: ${({ isOpen }) => isOpen && '10px 10px 5px -5px rgba(0, 0, 0, 0.15)'};
`

export const SelectBoxWrapper = styled.div`
  position: absolute;
  z-index: 3;
`

export const ListWrapper = styled.div``
export const ProductSelectWrapper = styled(ListWrapper)`
  position: relative;
  left: -20px;
`

export const ProductItemImageWrapper = styled.div`
  margin-top: 7px;
`

export const ProductItemImage = styled(Image)`
  width: 24px;
  height: 24px;
  border-radius: 9999px;
`
export const AllPortfolioIcon = styled(AllPortfolio)``

export const SkeletonWrapper = styled.div`
  width: 24px;
  margin-bottom: 4px;
`
export const PortfolioContentWrapper = styled.div`
  margin-bottom: 30px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    padding: 0 40px 0 45px;
  `}
`
export const PortfolioTitle = styled.h1`
  margin: 60px 0;
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 104.6%;
  letter-spacing: -1.6px;
  ${({ theme }) => theme.mediaWidth.Small`
    font-size: ${TextSize.big};
    line-height: 110%;
    letter-spacing: -1.28px;
    margin-top: 60px;
    margin-bottom: 30px;
  `}
`

export const ChartAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const PortfolioChart = styled(PortfolioChartComponent)``

export const ChartSkeletonWrapper = styled.div`
  margin-bottom: 30px;
`

export const SelectDropdownWrapper = styled.div`
  width: 377px;
  height: 47px;
`

export const ContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`
export const ConnectWrapper = styled.div`
  max-height: 800px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 20%;
  ${({ theme }) => theme.mediaWidth.Small`
    min-height: unset;
  `};
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: calc(100% - 80px);
    margin: 0 auto;
    margin-top: 20%;
  `};
`

export const ConnectTitle = styled.span`
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -1.6px;
  color: ${({ theme }) => theme.connectColor};
`

export const EmphasisSpan = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
`

export const ConnectTagline = styled.span`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 130%;
`
export const ConnectButton = styled(Button)`
  width: 150px;
  z-index: 2;
`

export const ConnectImageContainer = styled.div`
  position: relative;
  right: 0;
  bottom: 0;
  ${({ theme }) => theme.mediaWidth.Small`
    bottom: -114px;
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    left: -215px;
    bottom: -20px;
    min-height: 330px;
  `}
  min-height: 305px;
`

export const ConnectImageWrapper = styled.div`
  position: absolute;
  height: 375px;
  overflow: hidden;
  bottom: 0px;
  & img {
    width: 800px;
  }
  ${({ theme }) => theme.mediaWidth.Small`
    right: -45px;
    z-index: -1; /** or it will overlap the button on small screens */
  `}

  ${({ theme }) => theme.mediaWidth.Mobile`
    right: unset;
    z-index: -1; /** or it will overlap the button on small screens */
  `}
`

export const ContainerImage = styled.div`
  flex: 1;
`
